import React, { useState } from 'react';
import '../Assets/css/PointerGradient.css';

const PointerGradientText = (props) => {

  const { lable, children } = props;
  const [mousePosition, setMousePosition] = useState({ x: '30%', y: '30%' });
  const [hover, setHover] = useState(false);

  // Update mouse position on mouse move
  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setMousePosition({ x: `${x}%`, y: `${y}%` });
  };

  const handleMouseEnter = () => {
    setHover(true);
  };

  const handleMouseLeave = () => {
    setHover(false);
  };

  // Dynamically set the shadow using mouse position
  const textShadow = `${mousePosition.x / 30}px ${mousePosition.y / 30}px 15px rgba(255, 0, 0, 0.8), 
  ${mousePosition.x / 30}px ${mousePosition.y / 30}px 30px rgba(0, 255, 0, 0.8), 
  ${mousePosition.x / 30}px ${mousePosition.y / 30}px 45px rgba(0, 0, 255, 0.8),
  ${mousePosition.x / 30}px ${mousePosition.y / 30}px 60px rgba(255, 255, 0, 0.8)`;

  return (
    <div
      className="pointerGradient"
      onMouseMove={handleMouseMove}
      style={{
        // backgroundColor:'skyblue',
        fontWeight:'bold',
        '--mouse-x': mousePosition.x,
        '--mouse-y': mousePosition.y,
        display:'inline-flex',
        alignItems:'center',
        justifyContent:'center',
        textShadow: textShadow,  // Apply text shadow dynamically
      }}
    >
      {children}
      &nbsp;
      {lable}
    </div>
  );
};

export default PointerGradientText;
